module.exports = __webpack_public_path__ + "img/pic12.55d0effc.png";